import React, { useState, useContext, useEffect } from 'react'
import { Formik, Form, useFormikContext } from 'formik'
import * as Yup from 'yup'
import axios from 'axios'

import Field from '@/components/Field'
import Receipt from '@/components/Receipt'
import { StTag } from './style.css'
import { Link } from 'gatsby'

const RegisterSchema = Yup.object().shape({
  firstname: Yup.string()
    .min(3, 'Muy corto')
    .max(50, 'Demasiado largo')
    .required('Requerido'),
  lastname: Yup.string()
    .min(2, 'Muy corto')
    .max(50, 'Demasiado largo')
    .required('Requerido'),
  email: Yup.string().email('Email inválido').required('Requerido'),
  company: Yup.string()
    .min(2, 'Muy corto')
    .max(60, 'Demasiado largo')
    .required('Requerido'),
})

const RegisterForm = ({
  event,
  email = '',
  viewvideoaltiro = false,
  onRegister,
  slug,
}) => {
  const [useragent, setUseragent] = useState('')
  const [submitted, setSubmitted] = useState(false)
  const [submittedmsg, setSubmittedmsg] = useState({
    title: 'Gracias por tu registro',
    paragraph: 'Te hemos enviado un correo con la ruta. Te esperamos.',
  })
  const [errorMessage, setErrorMessage] = useState(false)

  useEffect(() => {
    if (typeof window !== `undefined`) {
      setUseragent(window.navigator.userAgent)
    }
  }, [])

  useEffect(() => {
    if (submitted && viewvideoaltiro) {
      onRegister()
    }
  }, [submitted, viewvideoaltiro])

  const regiones = [
    'Región de Arica y Parinacota',
    'Región de Tarapacá',
    'Región de Antofagasta',
    'Región de Atacama',
    'Región de Coquimbo',
    'Región de Valparaíso',
    'Región Metropolitana de Santiago',
    'Región del Libertador General Bernardo O’Higgins',
    'Región del Maule',
    'Región del Ñuble',
    'Región del Biobío',
    'Región de La Araucanía',
    'Región de Los Ríos',
    'Región de Los Lagos',
    'Región de Aysén del General Carlos Ibáñez del Campo',
    'Región de Magallanes y la Antártica Chilena',
  ]

  return (
    <div className="relative">
      <StTag className="absolute">
        <span className="uppercase text-white bg-rojo-900 px-6 py-4 text-sm">
          Regístrate
        </span>
      </StTag>
      {submitted ? (
        <Receipt event={event} message={submittedmsg} />
      ) : (
        <Formik
          initialValues={{
            firstname: '',
            lastname: '',
            email: email ? email : '',
            region: '',
            company: '',
            question: '',
          }}
          validationSchema={RegisterSchema}
          onSubmit={(values, { setSubmitting }) => {
            axios
              .post('https://strapi.lab.ltnext.com/registerwebinar/', {
                firstname: values.firstname,
                lastname: values.lastname,
                email: values.email,
                region: values.region ? values.region : '',
                company: values.company,
                question: values.question ? values.question : '',
                useragent: useragent,
                webinar: event.id,
                savelogin: viewvideoaltiro ? viewvideoaltiro : false,
              })
              .then(response => {
                console.log(response)
                if (response.status === 200) {
                  setSubmitted(true)
                }
              })
              .catch(err => {
                console.log('>>>err', err.response)
                if (
                  err.response.data.message ===
                  'Ya te habías registrado antes con este correo electrónico para este webinar.'
                ) {
                  setSubmittedmsg({
                    title: 'Te hemos enviado un correo de recordatorio',
                    paragraph:
                      'Ya te habías registrado antes con este correo electrónico para este webinar.',
                  })
                  setSubmitted(true)
                } else {
                  setErrorMessage(err.response.data.message)
                }
              })
          }}>
          {({ isSubmitting, handleSubmit }) => (
            <form className="text-left p-6" onSubmit={handleSubmit}>
              <div className="grid grid-cols-2 gap-4">
                <Field name="firstname" text="Nombres" placeholder="Nombres" />
                <Field
                  name="lastname"
                  text="Apellidos"
                  placeholder="Apellidos"
                />
              </div>
              <Field
                name="email"
                text="Email Corporativo"
                placeholder="tuemail@empresa.com"
              />
              <Field name="company" text="Empresa" placeholder="Tu empresa" />
              <Field
                name="region"
                as="select"
                text="¿De qué Región eres?"
                placeholder="Región a la que perteneces">
                <option value="">-- Selecciona una región --</option>
                {regiones.map((option, index) => {
                  return (
                    <option key={index} value={option}>
                      {option}
                    </option>
                  )
                })}
              </Field>

              <Field
                name="question"
                text="Pregunta para Webinar"
                placeholder="Tu pregunta"
                as="textarea"
              />
              {errorMessage && (
                <div className="mt-4">
                  <p>{errorMessage}</p>
                </div>
              )}
              <div className="mt-4">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="block w-full px-4 py-4 border border-transparent text-sm leading-5 font-medium rounded-lg text-white bg-rojo-900 hover:bg-red-500 focus:outline-none focus:shadow-outline-rojo focus:border-rojo-900 active:bg-indigo-900 transition duration-150 ease-in-out">
                  Regístrate
                </button>
              </div>
              <div className="text-center leading-none  mt-4">
                <span className="text-sm text-white">
                  Al registrarse aceptas nuestra{' '}
                  <Link
                    className="text-white underline"
                    to="/terminos-y-condiciones/">
                    política de privacidad
                  </Link>
                  .
                </span>
              </div>
            </form>
          )}
        </Formik>
      )}
    </div>
  )
}

export default RegisterForm
